export const userSegment = {
    gender: 'GENDER',
    country: 'COUNTRY',
    tag: 'TAG',
    optIn: 'OPT_IN',
    locale: 'LOCALE',
    registered: 'REGISTERED',
    paymentTimesDeposited: 'PAYMENT_TIMES_DEPOSITED',
    paymentTotalDeposited: 'PAYMENT_TOTAL_DEPOSITED',
    paymentBalance: 'PAYMENT_BALANCE',
    paymentRevenue: 'PAYMENT_REVENUE',
    game: 'GAME',
    group: 'GROUP'
}

export const genderRule = {
    allowedGenders: [],
    type: 'GENDER'
}

export const countryRule = {
    countries: [],
    operation: '',
    type: 'COUNTRY'
}

export const tagRule = {
    tags: [],
    operation: '',
    type: 'TAG'
}

export const localeRule = {
    locales: [],
    operation: '',
    type: 'LOCALE'
}

export const optInRule = {
    country: {
        countries: [],
        operation: ''
    },
    agreements: [],
    operation: '',
    type: 'OPT_IN'
}

export const registeredRule = {
    operation: '',
    dateFrom: '',
    dateTo: '',
    daysFrom: '',
    daysTo: '',
    type: 'REGISTERED'
}

export const paymentTimesDepositedRule = {
    amount: '',
    condition: '',
    timeOperation: '',
    dateFrom: '',
    dateTo: '',
    daysFrom: '',
    daysTo: '',
    currency: '',
    type: 'PAYMENT_TIMES_DEPOSITED'
}

export const paymentRevenueRule = {
    amount: '',
    condition: '',
    timeOperation: '',
    dateFrom: '',
    dateTo: '',
    daysFrom: '',
    daysTo: '',
    currency: '',
    type: 'PAYMENT_REVENUE'
}

export const paymentTotalDepositedRule = {
    amount: '',
    condition: '',
    timeOperation: '',
    dateFrom: '',
    dateTo: '',
    daysFrom: '',
    daysTo: '',
    type: 'PAYMENT_TOTAL_DEPOSITED'
}

export const paymentBalanceRule = {
    amount: '',
    operation: '',
    currency: '',
    type: 'PAYMENT_BALANCE'
}

export const gameRule = {
    amount: '',
    condition: '',
    timeOperation: '',
    dateFrom: '',
    dateTo: '',
    daysFrom: '',
    daysTo: '',
    type: 'GAME'
}

export const groupRule = {
    operation: '',
    type: 'GROUP'
}
